import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { IonItemSliding } from "@ionic/angular";
import { Quote } from "src/model/class/general classes/quote";
import { AlertService } from "src/service/alert.service";
import { SystemRouterService } from "src/service/system-router.service";
import { MomentFormats } from "src/model/class/general classes/moment-formats";

@Component({
    selector: "app-quote",
    templateUrl: "./quote.component.html",
    styleUrls: ["./quote.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuoteComponent implements OnInit {
  private _isSliding = false;

  public sizeIcon: number = 20;
  public dateTimeOutputFormat: string = "";
  public quoteDateOutputFormat: string = "";

  @Input() quote: Quote;
  @Input() ofDateLabel: string;
  @Input() periodFrom: string;
  @Input() toDateLabel: string;
  @Input() deleteQuotesConfirmTitle: string;
  @Input() deleteQuotesConfirmMsg: string;
  @Output() checkIsSliding = new EventEmitter<boolean>();
  @Output() onDeleteQuote = new EventEmitter<number>();

  constructor(
    private _alertService: AlertService,
    private _systemRouterService: SystemRouterService
  ) { }

  ngOnInit(): void {
    this.dateTimeOutputFormat = MomentFormats.MOMENT_DATETIME_DATE_EXTENDED;
    this.quoteDateOutputFormat =
      MomentFormats.MOMENT_DATETIME_FORMAT_DATE_YEAR;
  }

  /**
   *  Handle the event when the user slides and  clicks on the delete  button
   * @param item  IonItemSliding
   * @param event  any
   * @param idSelectedQuote  id of the selected quote
   */
  public onClickEditQuote(
    item: IonItemSliding,
    event: any,
    idSelectedQuote: number
  ) {
    this._isSliding = false;
    this.checkIsSliding.emit(this._isSliding);
    this._systemRouterService.navigateToQuotesDetailsEdit(idSelectedQuote);
    item?.close();
  }

  public async onClickDeleteQuote(
    item: IonItemSliding,
    event: any,
    idSelectedQuote: number
  ): Promise<void> {
    this._isSliding = false;
    this.checkIsSliding.emit(this._isSliding);

    try {
      const alertResponse: boolean =
        await this._alertService.presentAlertConfirmOrDismiss(
          this.deleteQuotesConfirmTitle,
          "",
          this.deleteQuotesConfirmMsg
        );
      if (alertResponse) {
        this.onDeleteQuote.emit(idSelectedQuote);
      }
    } catch (error) {
      await this._alertService.presentAlertSomethingWrong();
    } finally {
      item?.close();
    }
  }
}
